'use strict';
const content = require('@mindmup/mapjs-core/src/content/content');
module.exports = function FormatConverter(freemindImporter, preferRemote) {
	const self = this,
		updateResources = function (content) {
			let resourceKey;
			content.traverse(function (idea) {
				if (idea.attr && idea.attr.icon && idea.attr.icon.url) {
					if (preferRemote && idea.attr.icon.metaData && idea.attr.icon.metaData.remoteUrl) {
						idea.attr.icon.url = idea.attr.icon.metaData.remoteUrl;
					} else if (/^internal/.test(idea.attr.icon.url)) {
						resourceKey = idea.attr.icon.url.replace(/^[^:]*:/, '');
						if (content.resources && content.resources[resourceKey]) {
							idea.attr.icon.url = content.resources[resourceKey];
						} else {
							delete idea.attr.icon;
						}
					}
				}
			});
			delete content.resources;
			return content;
		};
	self.fromMup = function (fileContent) {
		const json = typeof fileContent === 'string' ? JSON.parse(fileContent) : fileContent;
		return updateResources(content(json));
	};
	self.fromMM = function (fileContent) {
		return content(freemindImporter(fileContent));
	};
};
